import React from 'react';

const ClapperBoardIcon = ({ width = 20, height = 20, color = '#424242', ...rest }, ref) => {
  return (
    <svg {...rest} width={width} height={height} ref={ref} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.66406 9.99935C1.66406 6.07098 1.66406 4.10679 2.88445 2.8864C4.10484 1.66602 6.06902 1.66602 9.99739 1.66602C13.9258 1.66602 15.8899 1.66602 17.1103 2.8864C18.3307 4.10679 18.3307 6.07098 18.3307 9.99935C18.3307 13.9277 18.3307 15.8919 17.1103 17.1123C15.8899 18.3327 13.9258 18.3327 9.99739 18.3327C6.06902 18.3327 4.10484 18.3327 2.88445 17.1123C1.66406 15.8919 1.66406 13.9277 1.66406 9.99935Z"
        stroke={color}
        strokeWidth="1.225"
      />
      <path d="M17.9193 6.66797H2.08594" stroke={color} strokeWidth="1.225" strokeLinecap="round" />
      <path d="M8.74479 2.08398L5.82812 6.66732" stroke={color} strokeWidth="1.225" strokeLinecap="round" />
      <path d="M14.1667 2.08398L11.25 6.66732" stroke={color} strokeWidth="1.225" strokeLinecap="round" />
      <path d="M5.41406 11.666H12.0807" stroke={color} strokeWidth="1.225" strokeLinecap="round" />
      <path d="M5.41406 14.584H9.9974" stroke={color} strokeWidth="1.225" strokeLinecap="round" />
    </svg>
  );
};

export default React.forwardRef(ClapperBoardIcon);
